import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NavbarComponent } from './navbar/navbar.component'

const routes: Routes = [{
	    path: '',
	    component: NavbarComponent
	}/*,{
	    path: 'list',
	    component: ListMaintenancesComponent
	},{
	    path: 'list/:id',
	    loadChildren: './detalle/detalle.module#DetalleModuleM'
	},{
	    path: 'new',
	    redirectTo:'list/0',
	    pathMatch:'full'
	}*/];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComponentsRoutingModule { }
